import { render, staticRenderFns } from "./InputTextMask.vue?vue&type=template&id=374bd64b&scoped=true"
import script from "./InputTextMask.vue?vue&type=script&lang=js"
export * from "./InputTextMask.vue?vue&type=script&lang=js"
import style0 from "./InputTextMask.vue?vue&type=style&index=0&id=374bd64b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374bd64b",
  null
  
)

export default component.exports